export { LeadsRegistryTable } from './ui/LeadsRegistryTable';
